import { render, staticRenderFns } from "./psychologistsComponent.vue?vue&type=template&id=c2681508&scoped=true"
import script from "./psychologistsComponent.vue?vue&type=script&lang=js"
export * from "./psychologistsComponent.vue?vue&type=script&lang=js"
import style0 from "./psychologistsComponent.vue?vue&type=style&index=0&id=c2681508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2681508",
  null
  
)

export default component.exports